import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Link, styled, Typography } from '@mui/material';

export const FooterLink = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'hasMarginTop' &&
    prop !== 'hasBorder' &&
    prop !== 'atTheBottom' &&
    prop !== 'backgroundColor' &&
    prop !== 'height' &&
    prop !== 'borderRadius' &&
    prop !== 'justifyContent',
})(
  ({
    theme,
    hasMarginTop,
    hasBorder,
    atTheBottom,
    backgroundColor,
    height,
    justifyContent,
    borderRadius,
  }) => ({
    display: 'flex',
    justifyContent: justifyContent || 'flex-end',
    backgroundColor,
    height: height ? `${height}` : '23px',
    border: hasBorder ? `1px solid ${theme.palette.colors.borderLine}` : 0,
    borderRadius: borderRadius || '5px',
    marginTop: hasMarginTop && '4px',
    padding: '0 8px',
    position: atTheBottom && 'absolute',
    bottom: atTheBottom && 0,
    width: '100%',
  }),
);

export const LinkStyled = styled(Link)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '5px',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const LinkText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'fontSize' && prop !== 'isTextBold',
})(({ theme, fontSize, isTextBold }) => ({
  fontSize: fontSize || '11px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontWeight: isTextBold ? 'bold' : '500',
}));

export const ArrowIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '11px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
